import { FeedbackModel } from "model";
import { Colors, Icon } from "swing-components";

import { translate } from "~utils";

type ModalSubFeedbackExistsProps = {
  feedback: FeedbackModel[];
  onDismiss: () => void;
};

export function ModalSubFeedbackExists({ feedback, onDismiss }: ModalSubFeedbackExistsProps) {
  // We can be fairly confident that we should only ever have
  // one feedback entity per sub request.
  const feedbackItem = feedback[0];
  return (
    <div className="modal-wrapper">
      <div className="modal-header">
        <div
          css={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <h2>{translate("FEEDBACK_EXISTS_TITLE")}</h2>
          <button onClick={onDismiss} css={{ backgroundColor: "transparent" }}>
            <Icon name="Close" color={Colors.blue500} />
          </button>
        </div>
      </div>
      <div className="modal-body">
        <div css={{ display: "flex", alignItems: "center", gap: 16 }}>
          <Icon name="Check Circle" color={Colors.green500} />
          <span css={{ fontWeight: "bold" }}>{translate("FEEDBACK_SUBMITTED_LABEL")}</span>
        </div>
        <div>
          <p css={{ padding: "16px 0" }}>
            {translate("FEEDBACK_EXISTS_BODY_1", {
              adminName: feedbackItem.adminName,
              subName: feedbackItem.subName,
            })}
          </p>
          <p>{translate("FEEDBACK_EXISTS_BODY_2")}</p>
        </div>
      </div>
    </div>
  );
}
